import invariant from 'invariant';
export const getTierCeiling = tier => {
  const tierCeiling = tier.ceiling;
  invariant(typeof tierCeiling === 'number', 'Ceiling cannot be unspecified for cloud');
  return tierCeiling;
};